import Pinterest from '../src/Pinterest';
export default Pinterest;
